import { render, staticRenderFns } from "./VisitorsFormBlock.vue?vue&type=template&id=0a0829c8&"
import script from "./VisitorsFormBlock.vue?vue&type=script&lang=js&"
export * from "./VisitorsFormBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports